<template>
  <HeaderPanel />
  <div class="leads-page">
    <h1>Заявки</h1>
    <div class="filters">
      <select v-model="filters.project_id" @change="onProjectChange">
        <option value="">Проект</option>
        <option v-for="p in projects" :key="p.id" :value="p.id">{{ p.name }} ({{ p.code }})</option>
      </select>
      <select v-model="filters.form_id">
        <option value="">Форма</option>
        <option v-for="f in forms" :key="f.id" :value="f.id">{{ f.name }} ({{ f.code }})</option>
      </select>
      <input v-model="filters.date_from" type="datetime-local" />
      <input v-model="filters.date_to" type="datetime-local" />
      <input v-model="filters.name" type="text" placeholder="Имя" />
      <input v-model="filters.phone" type="text" placeholder="Телефон" />
      <input v-model="filters.email" type="text" placeholder="Email" />
      <input v-model="filters.q" type="text" placeholder="Поиск payload" />
      <button @click="search">Найти</button>
      <button @click="reset">Сброс</button>
      <button @click="exportCsv">Экспорт CSV</button>
      <button @click="openCurlModal">Конструктор запроса</button>
    </div>

    <div class="meta">Всего: {{ total }} | Страница: {{ page }}</div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th><th>Дата</th><th>Проект</th><th>Форма</th><th>Имя</th><th>Телефон</th><th>Email</th><th>UTM</th><th>Payload</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in items" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ formatDate(row.submitted_at) }}</td>
            <td>{{ row.project_name }}</td>
            <td>{{ row.form_name }}</td>
            <td>{{ row.contact_name }}</td>
            <td>{{ row.contact_phone }}</td>
            <td>{{ row.contact_email }}</td>
            <td>{{ row.utm_source }}/{{ row.utm_medium }}/{{ row.utm_campaign }}</td>
            <td><button @click="openPayload(row.id)">Открыть</button></td>
          </tr>
          <tr v-if="items.length===0"><td colspan="9">Нет данных</td></tr>
        </tbody>
      </table>
    </div>

    <div class="pager">
      <button :disabled="page<=1" @click="prev">Назад</button>
      <button :disabled="page>=totalPages" @click="next">Вперед</button>
    </div>

    <div v-if="payloadModal.open" class="modal-overlay" @click.self="closePayload">
      <div class="modal-card">
        <div class="modal-head">
          <h3>Payload лида #{{ payloadModal.leadId }}</h3>
          <button @click="closePayload">Закрыть</button>
        </div>
        <pre class="payload-view">{{ payloadModal.pretty }}</pre>
      </div>
    </div>

    <div v-if="curlModal.open" class="modal-overlay" @click.self="closeCurlModal">
      <div class="modal-card curl-modal">
        <div class="modal-head">
          <h3>Конструктор запроса</h3>
          <button @click="closeCurlModal">Закрыть</button>
        </div>

        <div class="curl-form">
          <fieldset class="curl-fieldset">
            <legend>Проект</legend>
            <div class="mode-toggle">
              <label><input v-model="curlModal.projectMode" type="radio" value="existing" /> Существующий</label>
              <label><input v-model="curlModal.projectMode" type="radio" value="new" /> Новый</label>
            </div>
            <select
              v-if="curlModal.projectMode === 'existing'"
              v-model="curlModal.projectId"
              @change="onConstructorProjectChange"
            >
              <option value="">Выберите проект</option>
              <option v-for="p in projects" :key="p.id" :value="p.id">{{ p.name }} ({{ p.code }})</option>
            </select>
            <template v-else>
              <input v-model="curlModal.projectCode" type="text" placeholder="project_code *" />
              <input v-model="curlModal.projectName" type="text" placeholder="project_name" />
            </template>
          </fieldset>

          <fieldset class="curl-fieldset">
            <legend>Форма</legend>
            <div class="mode-toggle">
              <label>
                <input
                  v-model="curlModal.formMode"
                  type="radio"
                  value="existing"
                  :disabled="curlModal.projectMode === 'new'"
                />
                Существующая
              </label>
              <label><input v-model="curlModal.formMode" type="radio" value="new" /> Новая</label>
            </div>
            <select
              v-if="curlModal.formMode === 'existing'"
              v-model="curlModal.formId"
              :disabled="!curlModal.projectId"
            >
              <option value="">Выберите форму</option>
              <option v-for="f in constructorForms" :key="f.id" :value="f.id">{{ f.name }} ({{ f.code }})</option>
            </select>
            <template v-else>
              <input v-model="curlModal.formCode" type="text" placeholder="form_code *" />
              <input v-model="curlModal.formName" type="text" placeholder="form_name" />
            </template>
          </fieldset>

          <fieldset class="curl-fieldset">
            <legend>Контакт</legend>
            <input v-model="curlModal.name" type="text" placeholder="name" />
            <input v-model="curlModal.phone" type="text" placeholder="phone" />
            <input v-model="curlModal.email" type="text" placeholder="email" />
          </fieldset>

          <fieldset class="curl-fieldset">
            <legend>UTM</legend>
            <input v-model="curlModal.utm_source" type="text" placeholder="utm_source" />
            <input v-model="curlModal.utm_medium" type="text" placeholder="utm_medium" />
            <input v-model="curlModal.utm_campaign" type="text" placeholder="utm_campaign" />
          </fieldset>

          <fieldset class="curl-fieldset">
            <legend>Payload (JSON)</legend>
            <textarea v-model="curlModal.payloadJson" rows="4" placeholder='{"key": "value"}'></textarea>
            <p v-if="curlPayloadError" class="curl-error">{{ curlPayloadError }}</p>
          </fieldset>
        </div>

        <div class="curl-output">
          <div class="modal-head">
            <h4>cURL</h4>
            <button :disabled="!generatedCurl" @click="copyCurl">Копировать</button>
          </div>
          <pre class="payload-view">{{ generatedCurl || 'Заполните project_code и form_code' }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import HeaderPanel from '@/components/HeaderPanel.vue';

const SUBMIT_URL = 'https://ncht.bz/forms/submit';

const emptyCurlModal = () => ({
  open: false,
  projectMode: 'existing',
  projectId: '',
  projectCode: '',
  projectName: '',
  formMode: 'existing',
  formId: '',
  formCode: '',
  formName: '',
  name: '',
  phone: '',
  email: '',
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  payloadJson: '{}'
});

export default {
  components: { HeaderPanel },
  data() {
    return {
      projects: [],
      forms: [],
      items: [],
      total: 0,
      page: 1,
      pageSize: 20,
      payloadModal: { open: false, leadId: null, pretty: 'Загрузка...' },
      curlModal: emptyCurlModal(),
      constructorForms: [],
      filters: { project_id:'', form_id:'', date_from:'', date_to:'', name:'', phone:'', email:'', q:'' }
    };
  },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.total / this.pageSize)); },
    resolvedProjectCode() {
      if (this.curlModal.projectMode === 'existing') {
        const p = this.projects.find((x) => String(x.id) === String(this.curlModal.projectId));
        return p?.code || '';
      }
      return this.curlModal.projectCode.trim();
    },
    resolvedProjectName() {
      if (this.curlModal.projectMode === 'existing') {
        const p = this.projects.find((x) => String(x.id) === String(this.curlModal.projectId));
        return p?.name || '';
      }
      return this.curlModal.projectName.trim() || this.curlModal.projectCode.trim();
    },
    resolvedFormCode() {
      if (this.curlModal.formMode === 'existing') {
        const f = this.constructorForms.find((x) => String(x.id) === String(this.curlModal.formId));
        return f?.code || '';
      }
      return this.curlModal.formCode.trim();
    },
    resolvedFormName() {
      if (this.curlModal.formMode === 'existing') {
        const f = this.constructorForms.find((x) => String(x.id) === String(this.curlModal.formId));
        return f?.name || '';
      }
      return this.curlModal.formName.trim() || this.curlModal.formCode.trim();
    },
    parsedPayload() {
      const rawPayload = this.curlModal.payloadJson.trim();
      if (!rawPayload) return { error: '', value: {} };
      try {
        const value = JSON.parse(rawPayload);
        if (typeof value !== 'object' || value === null || Array.isArray(value)) {
          return { error: 'Payload должен быть JSON-объектом', value: null };
        }
        return { error: '', value };
      } catch {
        return { error: 'Невалидный JSON в payload', value: null };
      }
    },
    curlPayloadError() {
      return this.parsedPayload.error;
    },
    generatedCurl() {
      const projectCode = this.resolvedProjectCode;
      const formCode = this.resolvedFormCode;
      if (!projectCode || !formCode) return '';
      if (this.parsedPayload.error) return '';

      const payload = this.parsedPayload.value || {};
      const body = {
        project_code: projectCode,
        form_code: formCode
      };

      const projectName = this.resolvedProjectName;
      const formName = this.resolvedFormName;
      if (projectName) body.project_name = projectName;
      if (formName) body.form_name = formName;

      const name = this.curlModal.name.trim();
      const phone = this.curlModal.phone.trim();
      const email = this.curlModal.email.trim();
      if (name) body.name = name;
      if (phone) body.phone = phone;
      if (email) body.email = email;

      const utmSource = this.curlModal.utm_source.trim();
      const utmMedium = this.curlModal.utm_medium.trim();
      const utmCampaign = this.curlModal.utm_campaign.trim();
      if (utmSource) body.utm_source = utmSource;
      if (utmMedium) body.utm_medium = utmMedium;
      if (utmCampaign) body.utm_campaign = utmCampaign;

      if (Object.keys(payload).length) body.payload = payload;

      const json = JSON.stringify(body, null, 2);
      return `curl -X POST '${SUBMIT_URL}' \\\n  -H 'Content-Type: application/json' \\\n  -d '${json.replace(/'/g, "'\\''")}'`;
    }
  },
  watch: {
    'curlModal.projectMode'(mode) {
      if (mode === 'new') {
        this.curlModal.projectId = '';
        this.curlModal.formMode = 'new';
        this.curlModal.formId = '';
        this.constructorForms = [];
      }
    },
    'curlModal.formMode'(mode) {
      if (mode === 'new') this.curlModal.formId = '';
    }
  },
  async mounted() {
    await this.loadProjects();
    await this.load();
  },
  methods: {
    headers() {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      return { Authorization: `Bearer ${token}` };
    },
    async loadProjects() {
      const { data } = await axios.get('https://ncht.bz/forms/projects', { headers: this.headers() });
      this.projects = data || [];
    },
    async onProjectChange() {
      this.filters.form_id = '';
      if (!this.filters.project_id) {
        this.forms = [];
        return;
      }
      const { data } = await axios.get('https://ncht.bz/forms/forms', {
        headers: this.headers(),
        params: { project_id: this.filters.project_id }
      });
      this.forms = data || [];
    },
    params() {
      return { ...this.filters, page: this.page, page_size: this.pageSize, sort_by: 'submitted_at', sort_order: 'desc' };
    },
    async load() {
      const { data } = await axios.get('https://ncht.bz/forms/submissions', { headers: this.headers(), params: this.params() });
      this.items = data.items || [];
      this.total = data.total || 0;
    },
    async exportCsv() {
      const response = await axios.get('https://ncht.bz/forms/export.csv', {
        headers: this.headers(),
        params: this.params(),
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `forms-submissions-${Date.now()}.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async search() {
      this.page = 1;
      await this.load();
    },
    async reset() {
      this.filters = { project_id:'', form_id:'', date_from:'', date_to:'', name:'', phone:'', email:'', q:'' };
      this.forms = [];
      this.page = 1;
      await this.load();
    },
    async prev() {
      if (this.page > 1) {
        this.page -= 1;
        await this.load();
      }
    },
    async next() {
      if (this.page < this.totalPages) {
        this.page += 1;
        await this.load();
      }
    },
    async openPayload(leadId) {
      this.payloadModal = { open: true, leadId, pretty: 'Загрузка...' };
      try {
        const { data } = await axios.get(`https://ncht.bz/forms/submissions/${leadId}/payload`, { headers: this.headers() });
        const payload = data?.payload ?? {};
        this.payloadModal.pretty = JSON.stringify(payload, null, 2);
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || 'Не удалось загрузить payload';
        this.payloadModal.pretty = `Ошибка: ${message}`;
      }
    },
    closePayload() {
      this.payloadModal = { open: false, leadId: null, pretty: '' };
    },
    openCurlModal() {
      this.curlModal = { ...emptyCurlModal(), open: true };
      this.constructorForms = [];
    },
    closeCurlModal() {
      this.curlModal = emptyCurlModal();
      this.constructorForms = [];
    },
    async onConstructorProjectChange() {
      this.curlModal.formId = '';
      if (!this.curlModal.projectId) {
        this.constructorForms = [];
        return;
      }
      const { data } = await axios.get('https://ncht.bz/forms/forms', {
        headers: this.headers(),
        params: { project_id: this.curlModal.projectId }
      });
      this.constructorForms = data || [];
    },
    async copyCurl() {
      if (!this.generatedCurl) return;
      try {
        await navigator.clipboard.writeText(this.generatedCurl);
      } catch {
        const ta = document.createElement('textarea');
        ta.value = this.generatedCurl;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
    },
    formatDate(v) {
      return v ? new Date(v).toLocaleString('ru-RU') : '';
    }
  }
};
</script>

<style scoped>
.leads-page {
  padding: 16px;
  color: var(--text-color, #111827);
}
.filters { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; margin-bottom: 12px; }
.table-wrap { overflow: auto; }
table { width: 100%; border-collapse: collapse; }
th, td {
  border: 1px solid var(--surface-border, #d1d5db);
  padding: 8px;
}
th {
  background: var(--surface-ground, #f9fafb);
  color: var(--text-color, #111827);
}
td {
  background: var(--surface-card, #ffffff);
  color: var(--text-color, #111827);
}
.pager { margin-top: 12px; display: flex; gap: 8px; }
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-card {
  width: min(900px, 96vw);
  max-height: 90vh;
  overflow: auto;
  background: var(--surface-card, #fff);
  border-radius: 8px;
  border: 1px solid var(--surface-border, #d1d5db);
  padding: 12px;
  color: var(--text-color, #111827);
}
.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.payload-view {
  margin: 0;
  background: var(--surface-ground, #f6f8fa);
  border: 1px solid var(--surface-border, #e5e7eb);
  border-radius: 6px;
  padding: 12px;
  color: var(--text-color, #111827);
  white-space: pre-wrap;
  word-break: break-word;
}

.curl-modal {
  width: min(960px, 96vw);
}
.curl-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.curl-fieldset {
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 6px;
  padding: 10px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.curl-fieldset legend {
  padding: 0 6px;
  font-weight: 600;
}
.curl-fieldset input,
.curl-fieldset select,
.curl-fieldset textarea {
  width: 100%;
  box-sizing: border-box;
}
.mode-toggle {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.mode-toggle label {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.curl-output h4 {
  margin: 0;
  font-size: 1rem;
}
.curl-error {
  margin: 0;
  color: #dc2626;
  font-size: 0.875rem;
}
@media (max-width: 720px) {
  .curl-form {
    grid-template-columns: 1fr;
  }
}
</style>
